import { useEffect } from 'react';
import styled from 'styled-components';
import { useTranslation } from 'react-i18next';

import theme from 'shared/themes/default';

const TooltipGraphBasicStyle = styled.div`
  background: ${theme.palette.brand};
  box-shadow: 0px 0px 10px rgba(0, 0, 0, 0.15136);
  border-radius: 5px;
  padding: 8px;
  text-align: center;
`;

const TitleTooltip = styled.div`
  font-family: ${theme.fonts.primary};
  margin: 0 0 4px;
  font-weight: 700;
  font-size: 18px;
  color: ${theme.palette.mainDark};
`;

const LabelTooltip = styled.div`
  margin: 0;
  font-family: ${theme.fonts.primary};
  font-size: 14px;
  max-width: 180px;
  text-align: left;
`;

interface TooltipLabel {
  key?: string | number;
  info?: Record<string, any>;
}

interface PayloadItem {
  payload: {
    name: string;
    [key: string]: any;
  };
  value: number;
}

interface TooltipGraphBasicProps {
  active?: boolean;
  payload?: PayloadItem[];
  onActive: (name: string) => void;
  labels: (string | TooltipLabel)[];
}

const TooltipGraphBasic = ({
  active,
  payload,
  onActive,
  labels,
}: TooltipGraphBasicProps) => {
  const { t } = useTranslation();
  const [label1, label2] = labels;

  useEffect(() => {
    if (active && payload && payload.length) {
      const { name } = payload[0].payload;
      onActive(name);
    }
  }, [active, onActive, payload]);

  if (active && payload && payload.length) {
    let text1 = '';
    if (typeof label1 === 'object' && label1.key) {
      text1 = t(String(label1.key), {
        name: payload[0].payload.name,
        value: payload[0].value,
        ...label1.info,
      });
    } else if (typeof label1 === 'string') {
      text1 = label1.replace('{{name}}', payload[0].payload.name);
      text1 = text1.replace('{{value}}', String(payload[0].value));
    }

    let text2 = '';
    if (typeof label2 === 'object' && label2.key) {
      text2 = t(String(label2.key), {
        name: payload.length === 1 ? '0' : payload[1].payload.name,
        value: payload.length === 1 ? 0 : payload[1].value,
        ...label2.info,
      });
    } else if (typeof label2 === 'string') {
      text2 = label2.replace('{{name}}', payload[1]?.payload?.name || '');
      text2 = text2.replace('{{value}}', String(payload[1]?.value || 0));
    }

    return (
      <TooltipGraphBasicStyle>
        <TitleTooltip>{text1}</TitleTooltip>
        <LabelTooltip>{text2}</LabelTooltip>
      </TooltipGraphBasicStyle>
    );
  }
  return null;
};

export default TooltipGraphBasic;
export type { TooltipGraphBasicProps };
